import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-sms',
  templateUrl: './modal-sms.component.html',
  styleUrls: ['./modal-sms.component.scss']
})
export class ModalSMSComponent implements OnInit {

  icon: any;
  labelTitile: string;
  textDescription: any;
  status: any;


  constructor(@Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel) {

    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.icon = this.dataMessage.icon;
      this.textDescription = this.dataMessage.textDescription;
      this.status = this.dataMessage.status;
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }

  }

  ngOnInit() {
  }

}
